export default __webpack_public_path__ + "static/paulinoPat-bac7a172cb1e53490dffcab31a0ae732.jpg";